import {
    InputComponent,
    LabeledComponentDefinition,
    ValueComponentDefinition,
} from "components/components/Component";
import { InputBaseComponent } from "components/components/InputBaseComponent";
import { LabelElement } from "components/components/label/labelElement";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import $ from "jquery";
import { initTextAreaCompactWebComponent, TextAreaCompactElement } from "./components/textAreaCompact";
import template from "./textAreaCompact.hbs";

initTextAreaCompactWebComponent();

export class TextAreaCompactInput
    extends InputBaseComponent<TextAreaCompactInputDefinition>
    implements InputComponent {
    public static componentType = "textAreaCompactInput";
    private valueHasBeenInitialized = false;
    private element: TextAreaCompactElement;

    constructor(schema: TextAreaCompactInputDefinition) {
        super(schema);
        if (schema.labelKey == null || schema.labelKey.length === 0) {
            this.definition.labelWidth = 0;
        }
        if (this.definition.emptyWidth == null) {
            this.definition.emptyWidth = 0;
        }
        this.definition.inputWidth = 16 - (this.definition.labelWidth || 0) - this.definition.emptyWidth;
    }

    public render(): Element {
        let jqueryView = $(template(this.definition));
        this.view = jqueryView[0];
        this.element = this.view.querySelector("s6-textarea-compact");
        this.element.addEventListener("change", () => {
            fireDataChangedEvent(this, this.view, this.getValue());
        });
        return this.view;
    }

    public getValue(): string {
        return this.element.data;
    }

    public value(v: string) {
        if (v === undefined) {
            return;
        }

        this.valueHasBeenInitialized = true;
        this.element.data = v;
    }

    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }

    public setRequired(required: boolean) {
        let inputLabel = this.view.querySelector("s6-input-label");
        if (inputLabel != null) {
            (inputLabel as LabelElement).required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message;
    }

    public postRender(): Node {
        this.setDefaultValue();
        return this.view;
    }

    private setDefaultValue() {
        if (!this.valueHasBeenInitialized) {
            fireDataChangedEvent(this, this.view, this.getValue());
        }
    }
}

export interface TextAreaCompactInputDefinition extends LabeledComponentDefinition, ValueComponentDefinition {
    inputWidth?: number;
    emptyWidth?: number;
    rows?: number;
    maxlength?: number;
}
